var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-modal-btn",on:{"click":_vm.closeModal}},[_c('IconBase',{attrs:{"iconColor":"#111","viewBox":"0 0 329.26933 329","width":"100%","height":"100%","strokeWidth":"3px"}},[_c('IconClose')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }